import { gql } from '@apollo/client';

export const UPDATE_CONNECTED_APP = gql`
    mutation UpdateConnectedApp($input: UpdateConnectedAppInput!) {
        updateConnectedApp(input: $input) {
            id
            app
            schedulingLink
            userId
            email
            eventName
            status
            organizationUri
        }
    }
`;

export const DELETE_CONNECTED_APP = gql`
    mutation DeleteConnectedApp($input: DeleteConnectedApp!) {
        deleteConnectedApp(input: $input) {
            id
        }
    }
`;
